/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/check/CheckScanningProgressConfiguration.yaml
import { PartiallyConstructible } from '../../utils/utils';
/**
Configuration of visualization of the scanning progress - indeterminate progress.
*/
export class CheckScanningProgressConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<CheckScanningProgressConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Enable or disable the scanning progress visualization.
          
          Default is true
          */
        this.enabled = true;
        /**
          The color of the scanning progress.
          
          Default is "#40A9FF"
          */
        this.progressColor = '#40A9FF';
        /**
          The duration of a single scanning progress cycle animation in milliseconds.
          
          Default is 1000
          */
        this.animationDuration = 1000;
        if (source.enabled !== undefined) {
            this.enabled = source.enabled;
        }
        if (source.progressColor !== undefined) {
            this.progressColor = source.progressColor;
        }
        if (source.animationDuration !== undefined) {
            this.animationDuration = source.animationDuration;
        }
    }
}
//# sourceMappingURL=CheckScanningProgressConfiguration.js.map